import { utils } from '@hh/global.js'
import { sendViewCartEvent } from './gtag-helper-functions.js'

class HHHeader extends HTMLElement {
  static properties = {
    _scrollPos: {
      state: 0,
    },
  }

  constructor() {
    super()

    this.submenuOpen = false
  }

  checkForOpenSubMenu() {
    document.querySelectorAll('.js-submenu-menu').forEach((el) => {
      if (el.hasAttribute('aria-expanded') && el.getAttribute('aria-expanded') === 'true') {
        this.submenuOpen = true
      }
    })
  }

  connectedCallback() {
    const hasStickyHeader = !!document.querySelector('hh-sticky-header')

    if (hasStickyHeader && (this.dataset.page === 'index' || this.dataset.page == '404')) {
      this._scrollPos = window.pageYOffset || document.documentElement.scrollTop
      this.classList[this._scrollPos === 0 && !this.submenuOpen ? 'add' : 'remove']('is-transparent')

      this.addEventListener('stickyScrolled', this.stickyScroll.bind(this))
      this.addEventListener(
        'mobileMenuOpened',
        this.handleModalOpenened.bind(this)
      )
    }

    if (this.dataset.page != 'cart') {
      document.addEventListener('toggleCart', this.openCart.bind(this))
    }

    document.querySelector('#header-search-modal')?.classList.remove('hidden')

    if (this.dataset.page != 'cart') {
      document
        .querySelector('.js-overlay')
        ?.addEventListener('click', this.closeOverlay.bind(this))
    }

    this.hasStickyHeader = hasStickyHeader
  }

  openCart(e) {
    e?.detail?.event?.preventDefault()

    document.querySelector('html').classList.add('scroll-lock')
    document
      .querySelector('body')
      .classList.add('scroll-lock', 'mini-cart-is-active')
    document.querySelector('.js-overlay').classList.add('active')

    utils.pauseAllMedia()
    if (e.detail.key == 'notification') {
      document
        .querySelectorAll('hh-cart-notification')
        ?.forEach((el) => el.close())
    }
    sendViewCartEvent()
  }

  stickyScroll(e) {
    this.checkForOpenSubMenu()
    this._scrollPos = e.detail.value

    if (this.hasStickyHeader) {
      this.classList[
        this._scrollPos === 0 && !this.submenuOpen ? 'add' : 'remove'
      ]('is-transparent')
    }
  }

  handleModalOpenened(e) {
    if (this.hasStickyHeader) {
      this.classList[!e.detail.value ? 'add' : 'remove']('is-transparent')
    }
    this.classList[e.detail.value ? 'add' : 'remove']('is-open')
  }

  closeOverlay() {
    // Close mini-cart
    if (
      document.querySelector('body').classList.contains('mini-cart-is-active')
    ) {
      document.querySelector('hh-mini-cart')?.closeFn()
    }
    // Close header-submenu
    if (
      document
        .querySelector('body')
        .classList.contains('header-submenu-is-active')
    ) {

      document
        .querySelectorAll('hh-header-submenu')
        .forEach((submenu) => submenu.close())
    }
  }
}

customElements.define('hh-header', HHHeader)
